import { defineStore } from 'pinia'

function getDomainLanguage() {
  switch (window.location.hostname) {
    case 'lohnrechner.ch':
      return 'de-ch'
    case 'calculateur-salarial.ch':
      return 'fr-ch'
    case 'calcolare-salario.ch':
      return 'it-ch'
    default:
      return 'de-ch'
  }
}

export const useTextStore = defineStore('texts', {
  state: () => ({
    language: getDomainLanguage(),
    texts: {},
    loading: true
  })
})

export function toUnderscore(str) {
  // de-ch -> de_CH
  let parts = str.split('-')
  return parts[0] + '_' + parts[1].toUpperCase()
}

export function toDash(str) {
  // de_CH -> de-ch
  let parts = str.split('_')
  return parts[0] + '-' + parts[1].toLowerCase()
}

export function toPrefix(str) {
  if (str.includes('-')) {
    return str.split('-')[0]
  }
  return str.split('_')[0]
}
